// schedule (weekly Gantt) domain. task types + labels mirror the desktop
// (renderer.js:48, styles.css task-bar colors). colors are applied in CSS via
// a `task-<type>` class, so only the type list + labels live here.
export const TASK_TYPES = [
    'teak',
    'polishing',
    'washing',
    'pdi',
    'delivery',
    'seatrial',
    'engineinstall',
    'enginestartup',
    'upholstery',
    'stickers',
    'other',
];
export const TASK_LABELS = {
    teak: 'Teak',
    polishing: 'Polishing',
    washing: 'Washing',
    pdi: 'PDI',
    delivery: 'Delivery',
    seatrial: 'Sea Trial',
    engineinstall: 'Engine Install',
    enginestartup: 'Engine Start-up',
    upholstery: 'Upholstery',
    stickers: 'Stickers',
    other: 'Other',
};
/** SS-sourced task types (auto-synced from overview dates; user-added tasks untouched). */
export const SS_SCHED_TYPES = [
    'engineinstall',
    'enginestartup',
    'seatrial',
    'pdi',
    'delivery',
];
/** Monday of the week containing `d` (UTC), as YYYY-MM-DD. */
export function mondayOf(d) {
    const x = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
    const day = x.getUTCDay(); // 0=Sun
    const diff = day === 0 ? -6 : 1 - day;
    x.setUTCDate(x.getUTCDate() + diff);
    return x.toISOString().slice(0, 10);
}
/** the 7 ISO dates (Mon..Sun) of the week starting at `weekStart` (YYYY-MM-DD). */
export function weekDays(weekStart) {
    const base = new Date(`${weekStart}T00:00:00Z`);
    return Array.from({ length: 7 }, (_, i) => {
        const d = new Date(base);
        d.setUTCDate(d.getUTCDate() + i);
        return d.toISOString().slice(0, 10);
    });
}
/** does task [start,end] cover day (all YYYY-MM-DD)? */
export function taskCoversDay(task, day) {
    return task.start <= day && day <= task.end;
}
//# sourceMappingURL=schedule.js.map